import { NgModule } from '@angular/core';
import { LIB_CommonModule } from 'pbc.angular';
import { PostRechnungsVorlageCommandService } from '.';

@NgModule({
  imports: [
    LIB_CommonModule,
  ],
  providers: [PostRechnungsVorlageCommandService],
  exports: []
})
export class PostRechnungsVorlageCommandServiceModule { }
